import type { ReactNode } from "react"

export const filterMemberOption = (
  input: string,
  option?: { label?: string | ReactNode; value?: string | number | null }
): boolean => {
  return typeof option?.label === "string"
    ? option.label.toLowerCase().includes(input.toLowerCase())
    : false
}
